import {
  buildContentSheetAttachmentsPayload,
  buildMaterialPlanningAttachmentPayload,
  buildChapterPlanningAttachmentPayload,
  buildEditContentAttachmentPayload,
  buildEditMaterialPlanningAttachmentPayload,
  buildEditBlockChapterPlanningAttachmentPayload,
  buildReleasePayload,
  buildBatchReleasePayload,
} from "./attachments.builder";
import {
  deleteService,
  getService,
  patchService,
  postService,
} from "../../axios/services";

export function uploadContentSheetAttachments({ attachments, overrides }) {
  const payload = buildContentSheetAttachmentsPayload(attachments, overrides);

  return postService({
    endpoint: "Attachments",
    postData: payload,
    api: "v2",
  });
}

export function uploadMaterialPlanningAttachment({ attachment, materialId }) {
  const payload = buildMaterialPlanningAttachmentPayload(attachment);

  return postService({
    endpoint: `Planning/materials/${materialId}/attachments`,
    postData: payload,
    api: "v2",
  });
}

export function uploadChapterPlanningAttachment({
  attachment,
  chapterId,
  blockId,
}) {
  const payload = buildChapterPlanningAttachmentPayload(attachment);

  return postService({
    endpoint: `Planning/blocks/${blockId}/chapters/${chapterId}/attachments`,
    postData: payload,
    api: "v2",
  });
}

export function getSheetAttachments({
  contentId,
  scope = "ProjectSheet",
  pageSize = 9999,
}) {
  return getService({
    endpoint: "Attachments",
    api: "v2",
    params: {
      contentId,
      scope,
      pageSize,
    },
  });
}

export function getPlanningAttachments({ contentId }) {
  return getService({
    endpoint: `Planning/contents/${contentId}`,
    api: "v2",
  });
}

export function moveChapterToAnotherBlock({
  blockId,
  chapterId,
  blockIdToMove,
}) {
  return postService({
    endpoint: `Planning/blocks/${blockId}/chapters/${chapterId}/move`,
    postData: {
      newBlockId: blockIdToMove,
    },
    api: "v2",
  });
}

export function getAttachmentsActions({ attachmentIds }) {
  return postService({
    endpoint: "Attachments/actions",
    postData: { attachmentIds },
    api: "v2",
  });
}

export function postRelease({ payload }) {
  return postService({
    endpoint: "Releases",
    postData: payload,
    api: "v1",
  });
}

export function releaseAttachments({ contentId, releases, unreleases }) {
  return postRelease({
    payload: buildReleasePayload({
      contentId,
      releases,
      unreleases,
    }),
  });
}

export function releaseAttachmentsBatch({
  contentId,
  releases,
  unreleases,
}) {
  return postRelease({
    payload: buildBatchReleasePayload({
      contentId,
      releases,
      unreleases,
    }),
  });
}

export function editContentAttachment({ attachmentId, attachment }) {
  const payload = buildEditContentAttachmentPayload(attachment);

  return patchService({
    endpoint: `Attachments/${attachmentId}`,
    patchData: payload,
    api: "v2",
  });
}

export function deleteContentAttachment({ attachmentId }) {
  return deleteService({
    endpoint: `Attachments/${attachmentId}`,
    api: "v2",
  });
}

export function deletePlanningMaterial({ materialId }) {
  return deleteService({
    endpoint: `Planning/materials/${materialId}`,
    api: "v2",
  });
}

export function deletePlanningChapter({ blockId, chapterId }) {
  return deleteService({
    endpoint: `Planning/blocks/${blockId}/chapters/${chapterId}`,
    api: "v2",
  });
}

export function editMaterialPlanningAttachment({
  materialId,
  attachmentId,
  attachment,
}) {
  const payload = buildEditMaterialPlanningAttachmentPayload(attachment);

  return patchService({
    endpoint: `Planning/materials/${materialId}/attachments/${attachmentId}`,
    patchData: payload,
    api: "v2",
  });
}

export function editBlockChapterPlanningAttachment({
  blockId,
  chapterId,
  chapterAttachmentId,
  attachment,
}) {
  const payload = buildEditBlockChapterPlanningAttachmentPayload(attachment);

  return patchService({
    endpoint: `Planning/blocks/${blockId}/chapters/${chapterId}/attachments/${chapterAttachmentId}`,
    patchData: payload,
    api: "v2",
  });
}
